var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rate-table" },
    [
      _vm.error
        ? _c("form-field-messages", {
            attrs: { messages: { error: _vm.error } }
          })
        : _c("div", { staticClass: "rate-table--content" }, [
            _vm.tableData
              ? _c(
                  "div",
                  { staticClass: "rate-table--wrapper" },
                  [
                    _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.filter($event)
                          }
                        }
                      },
                      [
                        _c("fieldset", [
                          _c("div", { staticClass: "rate-table--filters" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rate-table--filter rate-table--filter__export"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "rate-table--link",
                                    attrs: {
                                      download: "",
                                      href: _vm.tableData.export_link
                                    }
                                  },
                                  [
                                    _c("ui-icon", {
                                      attrs: {
                                        symbol: "download",
                                        size: "medium"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "rate-table--link-label" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.tableData.options.texts
                                                .export_link_label
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rate-table--filter rate-table--filter__search"
                              },
                              [
                                _c(
                                  "ui-input",
                                  {
                                    attrs: {
                                      placeholder:
                                        _vm.tableData.options.texts
                                          .search_input_placeholder,
                                      facets: ["base", "large"]
                                    },
                                    on: { input: _vm.search }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.tableData.options.texts
                                                .search_input_label
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rate-table--filter rate-table--filter__dropdown"
                              },
                              [
                                _c(
                                  "ui-select",
                                  {
                                    attrs: {
                                      facets: ["base", "large"],
                                      value: _vm.tableData.categories[0]
                                    },
                                    on: { change: _vm.filterCategory }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.tableData.options.texts
                                                .dropdown_label
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.tableData.categories, function(
                                      category,
                                      index
                                    ) {
                                      return _c("ui-option", { key: index }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(category) +
                                            "\n                                "
                                        )
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rate-table--filter rate-table--filter__checkbox"
                              },
                              [
                                _c(
                                  "ui-checkbox",
                                  {
                                    attrs: { facets: ["base", "multiline"] },
                                    on: { change: _vm.onToggleRateDiff }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.tableData.options.texts
                                                .checkbox_label
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-client-table",
                      _vm._b(
                        { ref: "table" },
                        "v-client-table",
                        _vm.tableData,
                        false
                      ),
                      [
                        _c(
                          "tr",
                          {
                            attrs: { slot: "beforeFilters" },
                            slot: "beforeFilters"
                          },
                          _vm._l(_vm.tableData.subcolumns, function(
                            column,
                            index
                          ) {
                            return _c("th", { key: index }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(column) +
                                  "\n                    "
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "rate-table--loader" },
                  [_c("spinning-loader")],
                  1
                )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0dba7464", { render: render, staticRenderFns: staticRenderFns })
  }
}